import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CalculatedOrderRoute } from 'src/app/core/orders/models/orders.models';
import * as ordersSelector from '../../../../core/orders/store/selectors/orders.selector';
import * as L from 'leaflet';
import { filter, first } from 'rxjs/operators';
import { LatLngExpression } from 'leaflet';
import { tap } from 'rxjs/operators';
import { Order } from 'src/app/core/orders/models/orders.models';
import { MatDialogRef } from '@angular/material/dialog';
import { ElementRef, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as partnerSelectors from '../../../../core/partners/store/selectors/partners.selector';
import { Partner } from 'src/app/core/partners/models/partners.model';
import { CitiesService } from 'src/app/core/cities/services/cities.service';

@Component({
  selector: 'app-calculated-route-modal',
  templateUrl: './calculated-route-modal.component.html',
  styleUrls: ['./calculated-route-modal.component.css']
})
export class CalculatedRouteModalComponent implements OnInit {
  @ViewChild('mapContainer', { static: false }) mapContainer: ElementRef;
   isLoading$: Observable<boolean>;
   calculatedRoute$: Observable<CalculatedOrderRoute>;
   currentOrder$: Observable<Order>;
   private map;
   private marker;
   calculatedRoute: CalculatedOrderRoute;
   currentOrder: Order;
   citySelected: any;
   transformedRouteCoordinates: L.LatLngExpression[] = [];
    partner$: Observable<Partner>;
 
   constructor(
     private store: Store, 
     private dialogRef: MatDialogRef<CalculatedRouteModalComponent>,
     private citiesService: CitiesService
   ) {
     this.isLoading$ = this.store.pipe(select(ordersSelector.selectIsLoading));
     this.calculatedRoute$ = this.store.pipe(select(ordersSelector.selectCalculatedRoute));
     this.partner$ = this.store.pipe(select(partnerSelectors.selectPartner));
   }
 
   ngOnInit(): void {
     this.citySelected = this.citiesService.getUserSelectedCity();
     this.calculatedRoute$ = this.store.pipe(
       select(ordersSelector.selectCalculatedRoute),
       filter(route => !!route),
       first(),
       tap(calculatedRoute => {
         this.calculatedRoute = calculatedRoute;
         console.log('calculatedRoute', this.calculatedRoute);
 
          // Transformar las coordenadas para el componente del mapa
        if (this.calculatedRoute.route.geometry.coordinates) {
         this.transformedRouteCoordinates = this.calculatedRoute.route.geometry.coordinates.map(
           coord => [coord[1], coord[0]]
         );
       }
 
         // Añade un marcador para el punto de origen
         this.renderOriginLocationMarker();
       })
     );
     this.currentOrder$ = this.store.pipe(
       select(ordersSelector.selectCurrentOrder),
       filter(order => !!order),
       first(),
       tap(order => {
         this.currentOrder = order;
       })
     );
   }
 
   ngAfterViewInit(): void {
     this.initMap();
    
       if (this.mapContainer && this.mapContainer.nativeElement) {
         L.circleMarker([this.calculatedRoute.from_location.lat, this.calculatedRoute.from_location.lon], {
           stroke: true,
           color: '#eeeeee',
           weight: 2,
           fillColor: '#3880ff', // color para el punto de origen
           fillOpacity: 1,
           radius: 10,
           interactive: true
         }).addTo(this.map);
 
         // Añade un marcador para el punto de destino
         L.circleMarker([this.calculatedRoute.to_location.lat, this.calculatedRoute.to_location.lon], {
           stroke: true,
           color: '#eeeeee',
           weight: 2,
           fillColor: '#ff0000', // color para el punto de destino
           fillOpacity: 1,
           radius: 10,
           interactive: true
         }).addTo(this.map);
 
         // Añade una línea para la ruta a recorrer
         const coordinates: L.LatLngExpression[] = this.calculatedRoute.route.geometry.coordinates.map(coord => [coord[1], coord[0]]);
 
         const routeLine = L.polyline(coordinates, {
           color: 'blue',
           weight: 3,
           opacity: 0.5
         }).addTo(this.map);
 
         // Ajusta la vista del mapa para que incluya la ruta completa
         this.map.fitBounds(routeLine.getBounds());
       }
    
   }
 
   private initMap(): void {
     this.map = L.map('map', {
       center: [ this.citySelected.latitude, this.citySelected.longitude ], // Coordenadas de Valencia, Venezuela
       zoom: 13
     });
     const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
       maxZoom: 19,
       attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
     });
     
     tiles.addTo(this.map);
 
   }
 
   renderOriginLocationMarker(): void {
     if (this.marker) {
       this.map.removeLayer(this.marker);
       this.marker = null;
     }
 
     if (this.calculatedRoute.from_location && this.map) {
       const lat = this.calculatedRoute.from_location.lat;
       const lng = this.calculatedRoute.from_location.lon;
       const tooltip = 'Origen';
 
       this.marker = L.marker([lat, lng], { icon: L.icon({ iconUrl: 'assets/map-pin.svg' }) })
         .addTo(this.map)
         .bindTooltip(tooltip);
     }
   }
 
   onCancel() {
     this.dialogRef.close('cancel');
   }
 
   onAccept() {
     if (this.calculatedRoute.distance > 60) {
       const confirmResult = confirm(`Esta seguro de los datos ingresados la distancia supera los ${this.calculatedRoute.distance} km`);
       if (!confirmResult) {
         return;
       }
     }
     this.dialogRef.close('accept');
   }
}
